import React from 'react';
import ClientFields from './ClientFields';
import ProFields from './ProFields';
import { PaymentMethodBlock } from 'components/molecules/Blocks/PaymentMethodBlock';
import PolicyField from './PolicyField';
import AdresseLivraison from './AdresseLivraison';
import useStyle from '../formCommande.style';
import { Divider } from 'components/atoms/Dividers/Divider';
import { NgoField } from './NgoField';

export const FormCommandeFields = () => {
  const classes = useStyle();
  return (
    <>
      <ClientFields />
      <AdresseLivraison />
      <Divider />
      <ProFields />
      <NgoField />
      <PaymentMethodBlock />
      <div className={classes.buttondiv}>
        <PolicyField />
      </div>
    </>
  );
};
